// eslint-disable-next-line import/prefer-default-export
export const AUDIT_LOGS_HEADERS = {
  'x-haptik-tool-name': 'bot-builder',
};
